import api from "./api";

export interface ContractStatus {
  needsSignature: boolean;
  reason: string;
  contractType: "individual" | "duo" | "group" | null;
  contractFileId: string | null;
  contractVersion: string | null;
  signature: ContractSignature | null;
}

export interface ContractSignature {
  id: string;
  contractType: "individual" | "duo" | "group";
  fullName: string;
  acceptedTerms: boolean;
  signedAt: string;
  contractVersion: string;
  studentName: string;
  studentEmail: string;
}

export interface SignContractData {
  fullName: string;
  acceptedTerms: boolean;
}

export const contractService = {
  async getContractStatus(): Promise<ContractStatus> {
    const response = await api.get("/contract/status/");
    // Backend uses camelCase renderer, so fields come as camelCase
    return {
      needsSignature: response.data.needsSignature,
      reason: response.data.reason,
      contractType: response.data.contractType,
      contractFileId: response.data.contractFileId ?? null,
      contractVersion: response.data.contractVersion ?? null,
      signature: response.data.signature
        ? {
            id: response.data.signature.id,
            contractType: response.data.signature.contractType,
            fullName: response.data.signature.fullName,
            acceptedTerms: response.data.signature.acceptedTerms,
            signedAt: response.data.signature.signedAt,
            contractVersion: response.data.signature.contractVersion,
            studentName: response.data.signature.studentName,
            studentEmail: response.data.signature.studentEmail,
          }
        : null,
    };
  },

  async signContract(
    data: SignContractData,
  ): Promise<{ message: string; signature: ContractSignature }> {
    const response = await api.post("/contract/sign/", {
      fullName: data.fullName,
      acceptedTerms: data.acceptedTerms,
    });
    return {
      message: response.data.message,
      signature: {
        id: response.data.signature.id,
        contractType: response.data.signature.contractType,
        fullName: response.data.signature.fullName,
        acceptedTerms: response.data.signature.acceptedTerms,
        signedAt: response.data.signature.signedAt,
        contractVersion: response.data.signature.contractVersion,
        studentName: response.data.signature.studentName,
        studentEmail: response.data.signature.studentEmail,
      },
    };
  },

  getContractPdfUrl(
    contractType: "individual" | "duo" | "group",
    fileId?: string | null,
  ): string {
    // Prefer the file id from the backend (editable by the director); fall
    // back to the built-in defaults so older clients still work.
    const driveFileIds: Record<string, string> = {
      individual: "1-sWMc_yDgMvxzjQ4y5ECMtvtI1h9eqz_",
      duo: "1YvuLdN-Y9LOhFva9JMSGzdnR64rnz5lp",
      group: "15f76a_fG5WaKnAEfWm98bVZwRrWCdEI5",
    };
    const id = fileId || driveFileIds[contractType];
    return `https://drive.google.com/file/d/${id}/preview`;
  },
};
